import { root } from './fts';

export const fts = {
  ...root,
};
